const moduleName = 'measurementChart';

import {components, reducers} from 'linksoft';

import measurementChartContainer from './chart-container';
import reducer from './reducer';

components.add('measurement-chart', measurementChartContainer);

reducers.add(moduleName, reducer);

export default {
    name: moduleName,
    containers: [measurementChartContainer],
    reducer: reducer
};


// WEBPACK FOOTER //
// ./App/components/modules/measurement-chart/index.js